import CryptoJS from 'crypto-js'

const key = '8F6B2AK33DZE20A05E74C231B47AC8F9'
/**
 * 加密 --api
 * @param word string
 * @returns {*} string
 */
export function cipherText(word) { //word 为 string  mode为加密规则
  const secretKey = CryptoJS.enc.Utf8.parse(key) //key  为你的秘钥
  const srcs = CryptoJS.enc.Utf8.parse(word)
  const encrypted = CryptoJS.AES.encrypt(srcs, secretKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
  return encrypted.toString()
}
/**
 * 解密 --api
 * @param word string
 * @returns {*} string
 */
export function decrypted(word) {
  const secretKey = CryptoJS.enc.Utf8.parse(key)
  const decrypt = CryptoJS.AES.decrypt(word, secretKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
  return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}
